/* istanbul ignore file */
import React, { useState } from 'react';
import { Request, OneStopModal, ModalData, OneStopRequestLayout } from 'domain/shared/oneStop';
import CustomRequestFormFactory from 'domain/gpo/oneStop/CustomRequestForm';
import { SanitizedHtml } from 'framework/utils';

type CustomRequestFormWrapperProps = {
  request: Request;
};

const CustomRequestFormWrapper = ({ request }: CustomRequestFormWrapperProps) => {
  const [modalData, setModalData] = useState<Nullable<ModalData>>(null);

  const openModal = (content: string | React.ReactElement, title?: string) => {
    setModalData({ isOpen: true, content, title, requestId: request.id, requestType: request.type });
  };

  return (
    <>
      <OneStopRequestLayout request={request}>
        <CustomRequestFormFactory
          form={request.form}
          requestId={request.form ?? request.id}
          openModal={message => openModal(<SanitizedHtml html={message} />)}
        />
      </OneStopRequestLayout>
      <OneStopModal data={modalData} />
    </>
  );
};

export default CustomRequestFormWrapper;
